<div class="action-buttons">
  <div class="OrangeButton">
    <button mat-raised-button (click)="editProject()" class="button-color-fix inco-button">
      <mat-icon class="icon-color-fix">edit</mat-icon>
      Update Project
    </button>
  </div>
  <div class="OrangeButton">
    <button mat-raised-button (click)="createProject()" class="button-color-fix inco-button">
      <mat-icon class="icon-color-fix">add</mat-icon>
      Add Project
    </button>
  </div>
</div>

<table mat-table [dataSource]="projectsData" class="mat-elevation-z8 mat-table-custom inco-master-table" id="oshproject">
  <ng-container matColumnDef="projectId">
    <th mat-header-cell *matHeaderCellDef class="text-left">Project ID</th>
    <td mat-cell *matCellDef="let project" class="text-left">
      <p [innerHTML]="project.id"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="projectTitle">
    <th mat-header-cell *matHeaderCellDef class="text-left long-text-col">Project Title</th>
    <td mat-cell *matCellDef="let project" class="text-left long-text-col">
      <p [innerHTML]="project.projectTitle || '-'" [matTooltip]="project.projectTitle"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="projectResponsible">
    <th mat-header-cell *matHeaderCellDef class="text-left long-text-col">Point of contact</th>
    <td mat-cell *matCellDef="let project" class="text-left long-text-col">
      <p [innerHTML]="project.responsibleUser || '-'" [matTooltip]="project.responsibleUser"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="multiproject">
    <th mat-header-cell *matHeaderCellDef class="text-left">Multiproject</th>
    <td mat-cell *matCellDef="let project" class="text-left">
      <p [innerHTML]="getEnumLabel('multiproject', project.multiprojectId)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="investmentType">
    <th mat-header-cell *matHeaderCellDef class="text-left">Investment Type</th>
    <td mat-cell *matCellDef="let project" class="text-left">
      <p [innerHTML]="getEnumLabel('investmentType', project.investmentTypeId)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="informationTechnology">
    <th mat-header-cell *matHeaderCellDef>IT</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="getBooleanDisplay(project.informationTechnology)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="manufacturing">
    <th mat-header-cell *matHeaderCellDef>MFG</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="getBooleanDisplay(project.manufacturing)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="fieldOperations">
    <th mat-header-cell *matHeaderCellDef>FLD</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="getBooleanDisplay(project.fieldOperations)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="researchDevelopment">
    <th mat-header-cell *matHeaderCellDef>R&D | local R&D</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="getBooleanDisplay(project.researchDevelopment)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="bigR">
    <th mat-header-cell *matHeaderCellDef>R&D | BigR</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="getBooleanDisplay(project.bigR)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="maintenance">
    <th mat-header-cell *matHeaderCellDef>Maintenance %</th>
    <td mat-cell *matCellDef="let project">
      <p>{{ formatPercent(project.maintenance) }}</p>
    </td>
  </ng-container>
  <ng-container matColumnDef="expansion">
    <th mat-header-cell *matHeaderCellDef>Expansion %</th>
    <td mat-cell *matCellDef="let project">
      <p>{{ formatPercent(project.expansion) }}</p>
    </td>
  </ng-container>
  <ng-container matColumnDef="focus">
    <th mat-header-cell *matHeaderCellDef>Focus Project</th>
    <td mat-cell *matCellDef="let project">
      <p [innerHTML]="getBooleanDisplay(project.focus)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="phase">
    <th mat-header-cell *matHeaderCellDef class="text-left">Phase</th>
    <td mat-cell *matCellDef="let project" class="text-left nowrap-col">
      <p [innerHTML]="getPhaseLabel(project.phaseId)"></p>
    </td>
  </ng-container>
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let project">
      <button mat-icon-button class="branch-excellence-changelog-button" matTooltip="Update project" style="width:100%"
        (click)="updateProject(project.id)">
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>
  <ng-container matColumnDef="changeLog">
    <th mat-header-cell *matHeaderCellDef>History</th>
    <td mat-cell *matCellDef="let project">
      <button mat-icon-button class="branch-excellence-changelog-button" matTooltip="Change Log" style="width:100%"
        (click)="viewprojectHistory(project)">
        <mat-icon>history</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row class="tableheader" *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let project; columns: displayedColumns;" class="table-row">
  </tr>
</table>